module.exports = __webpack_public_path__ + "static/media/bo.028edd26.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/bo.svg
// module id = 70
// module chunks = 0